import { ModuleTypes } from "../../Shared/sharedInterfaces";

export function getModuleByName(moduleName: string): {
  retModules: ModuleTypes[];
  retCounter: number;
} {
  let retModules: ModuleTypes[] = [];
  let retCounter: number = 0;

  var storedArray: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );

  storedArray.map((module) => {
    if (module.name === moduleName) {
      retCounter = module.outputs
      retModules.push(module)
    }
  });

  const retdata = { retModules: retModules, retCounter: retCounter };
  return retdata;
}

// Get modules from database
// Return module and outputs counter
export function getModule(
  moduleType: string,
  onlySa: boolean,
): {
  retModules: ModuleTypes[];
  retCounter: number;
} {
  const retModules: ModuleTypes[] = [];
  let retCounter: number = 0;

  var storedArray: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  //console.log("jmods2: ", storedArray)
  //debugger
  // modules from database
  storedArray.map((module) => {
    if (module.type === moduleType) {
      if (onlySa == false) {
        retModules.push(module);
        retCounter = retCounter + module.outputs;
      } else {
        if (module.sa == 1) {
          retModules.push(module);
          retCounter = retCounter + module.outputs;
        }
      }

      if (moduleType === "CTD") {
        retModules.push(module);
        retCounter = retCounter + module.outputs;
      }

      //console.log("RET: ", retCounter)
      //console.log("MOD: ", module.outputs)
    }
  });

  var sortedModules: ModuleTypes[] = retModules.sort(
    (n1, n2) => n2.outputs - n1.outputs,
  );
  const retdata = { retModules: sortedModules, retCounter: retCounter };
  //console.log(retdata);
  return retdata;
}

export function getCtds() {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  // Find module in modules database
  //console.log("DBMods: ", dbMods)
  let ctds = [{}];

  if (dbMods) {
    dbMods.map((mod: ModuleTypes) => {
      if (mod.name.includes("CTD")) {
        //const buscons = mod.busConsumption
        ctds.push(mod);
      }
    });
  }
  // console.log ("findmod/ ", retMod)
  return ctds;
}

function getDbModules(): ModuleTypes[] {
  try {
    return JSON.parse(sessionStorage.getItem("DbModules") || "[]");
  } catch {
    return [];
  }
}

export function getModuleFromName(moduleType: string) {
  const mod = getDbModules().find((m) => m.name === moduleType);
  return mod;
}

export function getModuleFromType(moduleType: string) {
  const mod = getDbModules().find((m) => m.type === moduleType);

  return mod;
}

export function getModuleModFromType(moduleType: string) {
  const mod = getDbModules().find((m) => m.type === moduleType);
  debugger;
  return mod;
}

export function getIconFromName(modName: string) {
  const mod = getDbModules().find((m) => m.name === modName);
  return mod?.icon;
}

export function getOutputsFromName(modName: string) {
  const mod = getDbModules().find((m) => m.name === modName);
  return mod?.outputs;
}



export function getModTypeFromName(name: string) {
  const mod = getDbModules().find((m) => m.name === name);
  return mod?.type;
}

export function getAllModuleTypes() {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );

  let modTypes: string[] = [];

  if (dbMods) {
    dbMods.map((mod: ModuleTypes) => {
      if (mod.name) {
        //const buscons = mod.busConsumption
        modTypes.push(mod.name);
      }
    });
  }

  return modTypes;
}
